const DEFAULT_CATEGORIES = ["name", "animal", "place", "thing"];

const playedRounds = (roomData) => {
  const rounds = roomData?.rounds || {};
  return Object.keys(rounds)
    .map(Number)
    .filter((n) => Number.isFinite(n) && rounds[n]?.scores)
    .sort((a, b) => a - b)
    .map((n) => ({ number: n, data: rounds[n] }));
};

export function roundBreakdown(roomData, players) {
  return playedRounds(roomData).map(({ number, data }) => ({
    round: number,
    letter: data.letter || "",
    points: Object.fromEntries(players.map((p) => [p.id, data.scores[p.id]?.total ?? 0])),
  }));
}

const topNames = (totals, players) => {
  const max = Math.max(0, ...Object.values(totals));
  if (max === 0) return null;
  const names = players.filter((p) => totals[p.id] === max).map((p) => p.name);
  return { names, value: max };
};

export function gameHighlights(roomData, players) {
  const categories = roomData?.categories || DEFAULT_CATEGORIES;
  const uniqueCounts = Object.fromEntries(players.map((p) => [p.id, 0]));
  let bestRound = null;
  let closestCall = null;

  playedRounds(roomData).forEach(({ number, data }) => {
    players.forEach((player) => {
      const scores = data.scores[player.id];
      if (!scores) return;

      uniqueCounts[player.id] += categories.filter((c) => scores[c] >= 10).length;

      const total = scores.total ?? 0;
      if (total > (bestRound?.points ?? 0)) {
        bestRound = { points: total, names: [player.name], round: number, letter: data.letter || "" };
      } else if (bestRound && total === bestRound.points && number === bestRound.round) {
        bestRound.names.push(player.name);
      }

      if (!closestCall) {
        const category = data.coinFlips?.[player.id]?.[0];
        if (category) {
          const submission = (data.submissions || []).find((s) => s.userId === player.id);
          const answer = submission?.answers?.[category];
          if (answer) closestCall = { name: player.name, category, answer, round: number };
        }
      }
    });
  });

  const mostUnique = topNames(uniqueCounts, players);
  return {
    mostUnique: mostUnique && { names: mostUnique.names, count: mostUnique.value },
    bestRound,
    closestCall,
  };
}

export const joinNames = (names) =>
  names.length <= 2 ? names.join(" & ") : `${names.length} players`;
